import React from 'react'

function Main({image}) {
    return (
        <div  className='flex justify-center items-center' id='main'>
          <img className='w-full lg:w-fit' src={image} alt="" />
        </div>
    )
}

export default Main